import { useTrendSvg } from '@src/modules/onf/hooks/useTrendSvg';
import Chart from 'react-apexcharts';

function TrendBarChart({
  data,
  seriesData = {},
  colors,
  yAxisLabel = '',
  yAxisSuffix = '',
  yAxisPrefix = '',
  yAxisDecimalPoints = 0,
  yAxisLabelFormatter = null,
  toolTipFormatter = null,
  annotationYKey = 'value',
  annotationXKey = 'category',
  invertTrend = false,
  grayscaleTrend = false,
  height = 400,
  width = '100%',
}) {
  const {
    upRedSvg, upGreenSvg, downGreenSvg, downRedSvg, flatSvg,
    upGraySvg, downGraySvg,
  } = useTrendSvg();

  const categories = [...new Set(data.map((x) => x.category))];

  const points = data.map((item) => {
    let svgIcon;

    if (item.trendDirection === 'flat') {
      svgIcon = grayscaleTrend ? flatSvg : flatSvg;
    } else if (item.trendDirection === 'up') {
      if (grayscaleTrend) {
        svgIcon = upGraySvg;
      } else {
        svgIcon = invertTrend ? upGreenSvg : upRedSvg;
      }
    } else if (grayscaleTrend) {
      svgIcon = downGraySvg;
    } else {
      svgIcon = invertTrend ? downRedSvg : downGreenSvg;
    }

    return {
      x: item[annotationXKey],
      y: item[annotationYKey],
      marker: {
        size: 0,
        strokeWidth: 0,
        fillColor: 'transparent',
      },
      customSVG: {
        SVG: svgIcon,
        offsetX: -30,
        offsetY: -50,
      },
    };
  });

  const options = {
    chart: {
      animations: { enabled: false },
    },
    xaxis: {
      type: 'category',
      categories,
      labels: {
        style: {
          colors,
          fontWeight: 'bold',
        },
      },
      tickPlacement: 'between',
    },
    yaxis: [
      {
        forceNiceScale: true,
        title: { text: yAxisLabel },
        labels: {
          formatter: (value) => (yAxisLabelFormatter
            ? yAxisLabelFormatter(value)
            : `${yAxisPrefix}${value?.toFixed(yAxisDecimalPoints)}${yAxisSuffix}`),
        },
      },
    ],
    dataLabels: { enabled: false },
    colors,
    legend: { show: false },
    tooltip: {
      enabled: true,
      enabledOnSeries: [0],
      marker: { show: false },
      custom({ seriesIndex, dataPointIndex, w }) {
        if (toolTipFormatter) {
          return toolTipFormatter({ seriesIndex, dataPointIndex, w });
        }
        return null;
      },
    },
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: false,
      },
    },
    annotations: {
      points,
    },
  };

  return (
    <Chart
      options={options}
      series={seriesData}
      type="bar"
      width={width}
      height={height}
    />
  );
}

export default TrendBarChart;
